import { table } from '../../../../../../../../../theme/images';
import { StubbornToolboxProperties } from '../../../../../../../../business/StubbornToolboxMapping';

export const toolbox: StubbornToolboxProperties = {
  name: 'sterTable',
  label: 'Ster Table',
  category: 'Data Display',
  image: table,
};
